import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgLine = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 16 16" role="img" ref={ref} {...props}><path fill="none" d="M0 0h16v16H0z" /><path fill="currentColor" d="M13.381 9.25H2.708A1.313 1.313 0 0 1 1.5 7.95a1.22 1.22 0 0 1 1.208-1.2h10.573a1.22 1.22 0 0 1 1.208 1.2 1.167 1.167 0 0 1-1.108 1.3z" /></svg>;
const ForwardRef = forwardRef(SvgLine);
export default ForwardRef;